"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateDiffUnits = void 0;
var DateDiffUnits;
exports.DateDiffUnits = DateDiffUnits;
(function (DateDiffUnits) {
  DateDiffUnits[DateDiffUnits["Seconds"] = 1] = "Seconds";
  DateDiffUnits[DateDiffUnits["Minutes"] = 60] = "Minutes";
  DateDiffUnits[DateDiffUnits["Hours"] = 3600] = "Hours";
  DateDiffUnits[DateDiffUnits["Days"] = 86400] = "Days";
  DateDiffUnits[DateDiffUnits["Weeks"] = 604800] = "Weeks";
  DateDiffUnits[DateDiffUnits["Years"] = 31536000] = "Years";
})(DateDiffUnits || (exports.DateDiffUnits = DateDiffUnits = {}));